import * as React from 'react';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';
import French from '../Res/french.png';
import English from '../Res/english.png';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuList from '@mui/material/MenuList';
import Box from '@mui/material/Box';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'fr', label: 'Français', flag: French, flagWidth: 24 },
  { code: 'en', label: 'English', flag: English, flagWidth: 18 },
];

export default function Langue() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const langRef = React.useRef<HTMLButtonElement>(null);
  const current = (i18n.language || 'fr').slice(0, 2);

  const currentLang = languages.find((l) => current === l.code) || languages[0];

  const handleToggle = () => setOpen((v) => !v);
  const handleClose = () => setOpen(false);

  const selectLang = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <Box>
      <Button
        ref={langRef}
        id="lang-button"
        aria-controls={open ? 'lang-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open}
        variant="text"
        disableElevation
        onClick={handleToggle}
        endIcon={
          <KeyboardArrowDownIcon
            sx={{ transition: 'transform .2s', transform: open ? 'rotate(180deg)' : 'none' }}
          />
        }
        color="inherit"
        startIcon={<img src={currentLang.flag} width={currentLang.flagWidth} alt={currentLang.code} />}
      >
        {currentLang.code.toUpperCase()}
      </Button>
      <Popper
        open={open}
        anchorEl={langRef.current}
        placement="bottom-end"
        transition
        sx={{ zIndex: (theme) => theme.zIndex.modal }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: 'top right' }}>
            <Paper
              sx={{
                borderRadius: '10px',
                boxShadow: '0 8px 30px rgba(0,0,0,0.18)',
                overflow: 'hidden',
                mt: 0.5,
                minWidth: 160,
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="lang-menu"
                  onKeyDown={(e) => { if (e.key === 'Escape') handleClose(); }}
                  sx={{ py: 0.5 }}
                >
                  {languages.map((l) => (
                    <MenuItem
                      key={l.code}
                      onClick={() => selectLang(l.code)}
                      sx={{
                        px: 2,
                        py: 1,
                        mx: 0.5,
                        borderRadius: '8px',
                        '&:hover': { backgroundColor: 'action.hover' },
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: 36 }}>
                        <img src={l.flag} width={l.flagWidth} alt={l.label} />
                      </ListItemIcon>
                      <ListItemText primary={t(`texte.langue.${l.code === 'fr' ? 'francais' : 'anglais'}`)} />
                      {current === l.code && <CheckIcon fontSize="small" color="primary" />}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
}
